import React from "react";

import Select from "react-select";

const SelectSearch = () => {
  const data = [
    {
      value: "chocolate",
    },
    {
      value: "vanilla",
    },
    {
      value: "strawberry",
    },
  ];

  const formatOptionLabel = ({ value }) => (
    <p className="text-base text-primary">{value}</p>
  );
  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      color: "#7F8FA5",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }),
  };
  return (
    <div>
      <Select
        // closeMenuOnSelect={false}
        placeholder="Search items"
        options={data}
        className="selects"
        isClearable
        isMulti
        classNamePrefix="select-dropdown"
        formatOptionLabel={formatOptionLabel}
        styles={customStyles}
      />
    </div>
  );
};

export default SelectSearch;